export default __webpack_public_path__ + "536fdac3b6041a7491f3bec08e59bdee.svg";